// lib
import { PublicClientApplication } from "@azure/msal-browser";
// src
import config from "config";

const { clientId, tenantId } = config.oauthAzure;

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${config.root}/auth/callback`,
    postLogoutRedirectUri: config.root,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
});

const loginRequest = { scopes: ["openid", "profile", "email"] };

export const login = () => msalInstance.loginRedirect(loginRequest);
export const logout = () => msalInstance.logoutRedirect();
